import { gql } from "@apollo/client";
import { GuideEditorEventTemplateFragment } from "generated/schemaTypes";

export const GUIDE_EDITOR_EVENT_TEMPLATES_FRAGMENT = gql`
  fragment GuideEditorEventTemplateFragment on EventTemplate {
    id
    title
    atssyncGreenhouseJobStage {
      id
    }
    atssyncGreenhouseInterview {
      id
      name
    }
  }
`;

export type EventTemplate = GuideEditorEventTemplateFragment;
